import { formatDate } from '@eureka/utils/date-format';

export function generateImgTitle(chartName?:string) {
    if (!chartName) return ''
    return `${chartName}-${formatDate({
        date: Date.now(),
        forceFormat: 'YYYYMMDD',
    })}.png`
}
